import {
  DropDownItem,
  DropDownMenu,
  useTheme,
} from "@monolith-forensics/monolith-ui";
import {
  DownloadIcon,
  EditIcon,
  EyeIcon,
  MoreVerticalIcon,
  Trash2Icon,
} from "lucide-react";

export const ActionMenu = <T,>({
  item,
  onView,
  onEdit,
  onDelete,
  onDownload,
  items,
  disabledReasons,
}: {
  item: T;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onDownload?: () => void;
  items?: DropDownItem[];
  /**
   * Gray out a built in action and show why beside it (a disabled item can't
   * be hovered itself, so the reason is its own hoverable element).
   */
  disabledReasons?: { edit?: React.ReactNode; delete?: React.ReactNode };
}) => {
  const theme = useTheme();

  const handleDropDownAction = (action: DropDownItem, item: T) => {
    if (action.disabled) return;
    switch (action.value) {
      case "view":
        onView?.();
        break;
      case "edit":
        onEdit?.();
        break;
      case "delete":
        onDelete?.();
        break;
      case "download":
        onDownload?.();
        break;
      default:
        break;
    }
  };

  const dropDownItems: DropDownItem[] = [];

  if (onView) {
    dropDownItems.push({
      label: "View Item",
      value: "view",
      leftSection: <EyeIcon size={14} color={theme.palette.primary.main} />,
    });
  }

  if (onEdit) {
    dropDownItems.push({
      label: "Edit",
      value: "edit",
      leftSection: <EditIcon size={14} color={theme.palette.primary.main} />,
      ...(disabledReasons?.edit
        ? { disabled: true, rightSection: disabledReasons.edit }
        : {}),
    });
  }

  if (onDownload) {
    dropDownItems.push({
      label: "Download",
      value: "download",
      leftSection: (
        <DownloadIcon size={14} color={theme.palette.primary.main} />
      ),
    });
  }

  if (onDelete) {
    dropDownItems.push({
      label: "Delete",
      value: "delete",
      leftSection: <Trash2Icon size={14} color="orangered" />,
      ...(disabledReasons?.delete
        ? { disabled: true, rightSection: disabledReasons.delete }
        : {}),
    });
  }

  return (
    <div
      className="data-cell"
      style={{ maxWidth: 60, justifyContent: "center" }}
    >
      <DropDownMenu
        data={[...(items || []), ...dropDownItems]}
        buttonProps={{
          title: "Evidence Actions",
          size: "xxs",
          style: { padding: "0px 4px" },
          variant: "subtle",
        }}
        onItemSelect={(action) => handleDropDownAction(action, item)}
        dropDownProps={{
          style: { width: 175, maxWidth: 400 },
        }}
      >
        <MoreVerticalIcon size={14} />
      </DropDownMenu>
    </div>
  );
};
